// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"13f45c1e","732":"8e477661","749":"50beb308","903":"93a3bb15","959":"e7581cd7","977":"c98bbbdc"}[chunkId] + ".chunk.js";
};